import { render, staticRenderFns } from "./mobile-video.vue?vue&type=template&id=2238bd12&scoped=true&"
import script from "./mobile-video.vue?vue&type=script&lang=js&"
export * from "./mobile-video.vue?vue&type=script&lang=js&"
import style0 from "./mobile-video.vue?vue&type=style&index=0&id=2238bd12&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2238bd12",
  null
  
)

export default component.exports